import { Component, Inject, Input } from "@angular/core";
import { L10N_LOCALE, L10nLocale } from "angular-l10n";
import { PatientPartial } from "src/app/shared/interfaces/patient-partial";
import { PatientData } from "src/app/shared/interfaces/request-data";

@Component({
  selector: 'app-summary-order-title',
  templateUrl: './summary-order-title.component.html',
  styleUrls: ['./summary-order-title.component.css']
})
export class SummaryOrderTitleComponent {

    @Input() initialLoading = true;
    @Input() patientData: PatientPartial | PatientData;
    @Input() title = '';

    get patient() { return this.patientData instanceof PatientData ? this.patientData?.Nombre : this.patientData?.nombre; }

    constructor(@Inject(L10N_LOCALE) public locale: L10nLocale) {}

}